import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import { projectsDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";

import * as SC from "./styles";

export const LoaderItem = () => {
    return (
        <SC.ItemContainer
            $isLoading
            data-automation={projectsDataAutomation.loadingProjectItem}
        >
            <PixelPlaceholderLoader
                width={32}
                height={32}
                className="iconLoader"
            />
            <Stack gap="4px">
                <PixelPlaceholderLoader
                    width={144}
                    height={13}
                />
                <PixelPlaceholderLoader
                    width={69}
                    height={11}
                />
            </Stack>
        </SC.ItemContainer>
    );
};
